﻿import '../highcharts.js';

$(window).scroll(function () {
	var allNavItems = document.querySelectorAll('[id*="--nav-item"]');
	var allSections = document.querySelectorAll('section[id]');
	var currentPosition = $(window).scrollTop();

	allSections.forEach(element => {

		var elementTopPosition = $(element).offset().top - 200;
		var elementHeight = $(element).outerHeight();

		if (currentPosition >= elementTopPosition && currentPosition < elementTopPosition + elementHeight) {

			const targetNavItem = document.querySelector(`div[id=${element.id}--nav-item]`);

			if (targetNavItem) {

				allNavItems.forEach(item => _utils.classListRemove(item, 'upper-panel--nav-item__active'));
				_utils.classListAdd(targetNavItem, 'upper-panel--nav-item__active');

			}
		}
	});
})